import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { nonNullish } from '../../../lib/non-nullish';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  styleUrls: ['./forgot-password-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ForgotPasswordDialogComponent implements OnInit {
  @Output()
  submitted = new EventEmitter<string>();
  @Input({ required: true }) isSendNewPasswordButtonClicked$ =
    new BehaviorSubject<boolean>(false);
  @Input() firstValue: string | undefined;
  @Input() set prepopulatedEmail(email: string) {
    this.email.setValue(email);
  }

  readonly email = new FormControl('', {
    validators: [Validators.required, Validators.email],
  });

  ngOnInit() {
    if (this.firstValue) {
      this.email.setValue(this.firstValue);
    }
  }

  submitClicked(e: SubmitEvent) {
    e.preventDefault();
    this.submitted.emit(nonNullish(this.email.value));
  }
}
